import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/features/auth/auth-provider";

/** Legacy `/onboarding` route — beta workspaces use `/onboarding/beta`. */
export function OnboardingPage() {
  const { ready, provisioned, workspace } = useAuth();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!provisioned) {
    return <Navigate to="/request-access" replace />;
  }

  if (workspace?.type === "BETA" && workspace.needsOnboarding) {
    return <Navigate to="/onboarding/beta" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
